/**
 * services/userService.ts - User Management API Service
 */

import apiClient from './apiClient';

export interface User {
  _id?: string;
  id?: string;
  username: string;
  password?: string;
  name: string;
  email: string;
  role: 'super-admin' | 'admin' | 'preparer' | 'deliverer' | 'editor' | 'read-only';
  permissions: string[];
  status: 'active' | 'inactive' | 'suspended';
  isAdmin?: boolean;
  lastLogin?: string;
  createdAt?: string;
  vendorId?: string | null;
}

class UserService {
  private basePath = '/users';

  async getAll(): Promise<User[]> {
    try {
      return await apiClient.get<User[]>(this.basePath);
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  }

  async getById(id: string): Promise<User> {
    try {
      return await apiClient.get<User>(`${this.basePath}/${id}`);
    } catch (error) {
      console.error('Error fetching user:', error);
      throw error;
    }
  }

  async create(userData: Omit<User, '_id' | 'id'>): Promise<User> {
    try {
      return await apiClient.post<User>(this.basePath, userData);
    } catch (error) {
      console.error('Error creating user:', error);
      throw error;
    }
  }

  async update(id: string, userData: Partial<User>): Promise<User> {
    try {
      return await apiClient.put<User>(`${this.basePath}/${id}`, userData);
    } catch (error) {
      console.error('Error updating user:', error);
      throw error;
    }
  }

  async delete(id: string): Promise<void> {
    try {
      await apiClient.delete(`${this.basePath}/${id}`);
    } catch (error) {
      console.error('Error deleting user:', error);
      throw error;
    }
  }
}

const userService = new UserService();
export default userService;
